currentVersion = "v2"
themeSet = "custom"
title = "Babyfur Interest Benchmark"
subtitle = "What brings you to ABDL/Babyfur?"
nameLabel = "Name"
attributeTerm = "interest"
attributeTermPlural = "interests"

[versions.v1]
attributeIds = [
  "diapers",
  "little",
  "middle",
  "big",
  "wetting",
  "messing",
  "regression",
  "artwork",
  "chastity",
  "bondage",
  "humiliation",
  "fursuits",
  "kink",
]
minRating = 0
maxRating = 10
labelInterval = 2

[versions.v2]
attributeIds = [
  "diapers",
  "toys",
  "little",
  "middle",
  "big",
  "wetting",
  "messing",
  "regression",
  "artwork",
  "chastity",
  "bondage",
  "humiliation",
  "fursuits",
  "kink",
  "ds",
  "breastfeeding",
]
minRating = 0
maxRating = 10
labelInterval = 2

[defaultLabels]
0 = "Hard Boundary"
1 = "Averse"
2 = "Tolerant"
3 = "Ambivalent"
4 = "Curious"
5 = "Interested"
6 = "Enjoys"
7 = "Preference"
8 = "Important"
9 = "Essential"
10 = "Core Identity"

[[attributes]]
id = "diapers"
name = "Diapers"
description = "Wearing/Using Diapers"

[[attributes]]
id = "little"
name = "Little"
description = "Roleplaying as a Little"

[[attributes]]
id = "middle"
name = "Middle"
description = "Roleplaying as a Middle"

[[attributes]]
id = "big"
name = "Caregiver"
description = "Caring for Others"

[[attributes]]
id = "wetting"
name = "Wetting"
description = "Wetting Diapers"

[[attributes]]
id = "messing"
name = "Messing"
description = "Messing Diapers"

[[attributes]]
id = "regression"
name = "Regression"
description = "Feeling like someone/something else has made you little."

[[attributes]]
id = "artwork"
name = "Artwork"
description = "Appreciating (or creating) artwork in this space."

[[attributes]]
id = "chastity"
name = "Chastity"
description = "Preventing sexual activity"

[[attributes]]
id = "bondage"
name = "Bondage"
description = "Restrained movement"

[[attributes]]
id = "humiliation"
name = "Humiliation"
description = "Embarassment or Teasing"

[[attributes]]
id = "fursuits"
name = "Fursuits"
description = "Wearing/Appreciating Fursuits"

[[attributes]]
id = "kink"
name = "Kink/Sexual"
description = "Being aroused by activities"

[[attributes]]
id = "ds"
name = "D/s Dynamic"
description = "Power exchange or Dom/Sub Dynamic"

[[attributes]]
id = "breastfeeding"
name = "Breastfeeding"
description = "(Simulated or Real) Breastfeeding"

[[attributes]]
id = "toys"
name = "Toys & Accessories"
description = "Age-appropriate toys, games, and environment"